import React from 'react'
import { usePage } from '@inertiajs/react'

import Select from 'react-tailwindcss-select'
import { Input } from '@material-tailwind/react'

import LoadingButton from '@/Shared/LoadingButton'
import DeleteButton from '@/Shared/DeleteButton'

export default function({
                            handleSubmit,
                            errors,
                            data,
                            setData,
                            processing,
                            isEdit,
                            deleted_at,
                            destroy
                        }) {
    const { districts, divisions } = usePage().props

    return (
        <form name="createForm" onSubmit={handleSubmit} className="mt-8">
            <div className="flex flex-col gap-4 md:flex-row">
                <Select
                    label="Select District"
                    name="distrcit"
                    error={errors.district_id}
                    primaryColor="indigo"
                    value={
                        data.district_id && {
                            value: data.district_id,
                            label: districts.find(
                                district => district.id === data.district_id
                            ).name
                        }
                    }
                    isSearchable
                    options={districts.map(district => ({
                        label: district.name,
                        value: district.id
                    }))}
                    onChange={option => setData('district_id', option.value)}
                />

                <Select
                    label="Select Division"
                    name="division"
                    error={errors.division_id}
                    primaryColor="indigo"
                    value={
                        data.division_id && {
                            value: data.division_id,
                            label: divisions.find(
                                division => division.id === data.division_id
                            ).name
                        }
                    }
                    isSearchable
                    options={divisions.map(division => ({
                        label: division.name,
                        value: division.id
                    }))}
                    onChange={option => setData('division_id', option.value)}
                />
            </div>

            <div className="flex flex-col gap-4 mt-4 md:flex-row">
                <Input
                    size="md"
                    label="Name"
                    name="name"
                    error={errors.name}
                    value={data.name}
                    onChange={e => setData('name', e.target.value)}
                />
            </div>

            <div className="mt-8 flex items-center justify-end gap-x-4 border-t border-gray-200 bg-gray-100 px-8 py-4">
                {(!deleted_at && isEdit) && (
                    <DeleteButton onDelete={destroy}>Delete Hospital</DeleteButton>
                )}

                <LoadingButton
                    loading={processing}
                    type="submit"
                    className="btn-indigo"
                >
                    {isEdit ? 'Update' : 'Create'} Hospital
                </LoadingButton>
            </div>
        </form>
    )
}
